<template>
  <div class="data-percent-averages">
    <div class="dpa-body">
      <slot name="content"></slot>
    </div>

    <div class="dpa-footer" v-if="isDataIn">
      <p>*Data represents percent averages</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isDataIn: { type: Boolean, default: false }
  }
};
</script>
<style lang="scss" scoped>
.data-percent-averages {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  padding: 0 8px;

  .dpa-body {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    min-width: 181px;
  }

  .dpa-footer {
    width: 100%;
    font-family: "Roboto-Light";
    font-size: 10px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #ffffffc2;
    padding-right: 1.45rem;
  }
}
</style>
